@if (order$ | async; as order) {
  <div class="header-order">
    <div class="row">
      <div class="col-12 col-sm-9">
        <h1>{{ order.batchId }}</h1>
      </div>
      <div class="col-12 col-sm-3 text-right">
        @if (order.status === 'RESERVED') {
          <button class="btn btn-primary-icon m-r-8" (click)="editOrder(order.id)"
            [cm-tooltip]="'Order.Edit_Order' | trans">
            <span class="cm-icon cm-icon-edit" aria-hidden="true"></span>
          </button>
        }
        <button class="btn btn-primary-icon" (click)="navigateToOrderDetail(order.id)"
          [cm-tooltip]="'Order.Details' | trans">
          <span class="cm-icon cm-icon-right" aria-hidden="true"></span>
        </button>
      </div>
    </div>
    <div class="row status-bar">
      <div class="col-10">
        <div class="inline-notification"
          [cm-tooltip]="'Order.Status' | trans">
          <div class="item-left">
            @if (order.status === 'RESERVED') {
              <span
              class="cm-icon cm-icon-time-fill cl-warning-color small" aria-hidden="true"></span>
            }
            @if (order.status === 'OPEN') {
              <span class="cm-icon cm-icon-creditcard cl-warning-color small"
              aria-hidden="true"></span>
            }
            @if (order.status === 'COMPLETE') {
              <span
              class="cm-icon cm-icon-verification cl-success-color small" aria-hidden="true"></span>
            }
            @if (order.status === 'EXPIRED') {
              <span class="cm-icon cm-icon-time-fill cl-error-color small"
              aria-hidden="true"></span>
            }
            @if (order.status === 'CANCELED') {
              <span class="cm-icon cm-icon-warning cl-error-color small"
              aria-hidden="true"></span>
            }
            @if (order.status === 'REFUNDED') {
              <span class="cm-icon cm-icon-refund cl-black-50 small"
              aria-hidden="true"></span>
            }
          </div>
          <div class="title">
            <span class="cl-selected-color">
              {{ ('Order_Status.' + order.status | trans) }}
            </span>
          </div>
        </div>
        @if (order.importId) {
          <div class="inline-notification"
            [cm-tooltip]="'Order_Detail.Go_To_Import' | trans"
            [routerLink]="['/settings/imports', order.importId]">
            <div class="item-left">
              <span class="cm-icon cm-icon-pop-in cl-selected-color small" aria-hidden="true"></span>
            </div>
            <div class="title">
              <span class="cl-selected-color">
                {{ ('General.Imported' | trans) }} - {{ order.externalReference }}
              </span>
            </div>
          </div>
        }
        @if (order.campaignId) {
          <div class="inline-notification"
            [cm-tooltip]="'Order_Detail.Go_To_Campaign' | trans"
            [routerLink]="['/settings/campaigns', order.campaignId]">
            <div class="item-left">
              <span class="cm-icon cm-icon-megaphone cl-selected-color small" aria-hidden="true"></span>
            </div>
            <div class="title">
              <span class="cl-selected-color">
                {{ order.campaign.name }}
              </span>
            </div>
          </div>
        }
      </div>
      <div class="col-2 text-right">
        <cm-context-menu>
          @if (order.status === 'COMPLETE') {
            <cm-option data-icon="email"
              [attr.data-display]="('Order_Detail.Resend_Email' | trans)"
            (cm-option-clicked)="onResendOrder(order,'EMAIL')"></cm-option>
            <cm-option data-icon="message"
              [attr.data-display]="('Order_Detail.Resend_SMS' | trans)"
            (cm-option-clicked)="onResendOrder(order,'SMS')"></cm-option>
            <cm-context-menu-line></cm-context-menu-line>
            <cm-option data-icon="download"
              [attr.data-display]="('General.Download' | trans)"
            (cm-option-clicked)="onDownloadOrderClick(order)"></cm-option>
            <cm-context-menu-line></cm-context-menu-line>
          }
          <cm-option data-icon="edit"
            [disabled]="order.isGuestManager ? true : null"
            [attr.data-tooltip-text]="order.isGuestManager ? ('Order.Cannot_Move_Guest_Manager_Orders' | trans) : null"
            [attr.data-display]="('Order_Detail.Move_Order' | trans)"
            (cm-option-clicked)="onMoveOrder(order.id)">
          </cm-option>
          @if (order.status === 'COMPLETE') {
            <cm-context-menu-line></cm-context-menu-line>
            <cm-option
              class="cl-red"
              data-icon="close"
              [attr.data-display]="('General.Cancel' | trans)"
            (cm-option-clicked)="onCancelOrder(order.id)"></cm-option>
          }
        </cm-context-menu>
      </div>
    </div>
  </div>
  <cm-expansion-panel data-is-open data-no-border>
    <cm-expansion-panel-header>
      <p style="font-weight: bold">{{ ('Order_Detail.Order_Summary' | trans) }}</p>
    </cm-expansion-panel-header>
    <cm-expansion-panel-content slot="content">
      <app-order-summary [order]="order"></app-order-summary>
    </cm-expansion-panel-content>
  </cm-expansion-panel>
  <cm-expansion-panel data-is-open data-no-border>
    <cm-expansion-panel-header>
      <p style="font-weight: bold">{{ ('Order_Detail.Customer' | trans) }}</p>
    </cm-expansion-panel-header>
    <cm-expansion-panel-content slot="content">
      @if (order.customer) {
        <div class="row">
          <div class="col-10">
            <div class="customer-name">{{ order.customer.getName() }}</div>
            <div class="customer-external-reference">{{ order.customer.externalReference1 }}</div>
            <div class="customer-contact">{{ order.customer.email }}</div>
          </div>
          <div class="col-2 text-right">
            <button class="btn btn-primary-icon" [routerLink]="['/customers', order.customer.id]">
              <span class="cm-icon cm-icon-right" aria-hidden="true"></span>
            </button>
          </div>
        </div>
      }
    </cm-expansion-panel-content>
  </cm-expansion-panel>
  <cm-expansion-panel data-no-border>
    <cm-expansion-panel-header>
      <p style="font-weight: bold">{{ ('Order_Detail.Activity_Log' | trans) }}</p>
    </cm-expansion-panel-header>
    <cm-expansion-panel-content slot="content">
      <app-activity-log-v2 [orderIds]="[order.id]"></app-activity-log-v2>
    </cm-expansion-panel-content>
  </cm-expansion-panel>
} @else {
  <cm-indicator></cm-indicator>
}

